'use strict';

HIconDropdownComponent.$inject = ['$element'];

function HIconDropdownComponent($element) {
    const self = this;

    self.handleClick = () => {
        setTimeout(() => {
            $element.find('.icon-btn.selected').focus();
        }, 50);
    };
}

angular
    .module("harriApp")
    .component("hIconDropdown", {
        controller: HIconDropdownComponent,
        bindings: {
            ngModel: '=',
            name: '<'
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-icon-dropdown/h-icon-dropdown.component.ng.html'
    });


